import * as HLF from "html-living-framework";
import {Callback} from "../core/Reflection";
import {OptionId, SlotId, StoryInjection} from "../data/StoryModel";
import {GameManager} from "../managers/GameManager";
import {StoryCreator} from "../states/StoryCreator";

export class SceneInjectionOptionFilter implements StoryInjection {

    private readonly rules: Array<[SlotId, OptionId | OptionId[], StoryInjection] | StoryInjection>;

    constructor(...rules: Array<[SlotId, OptionId | OptionId[], StoryInjection] | StoryInjection>) {
        this.rules = rules;
    }

    public execute(storyCreator: StoryCreator, cb: Callback): void {
        const gameManager = GameManager.instance;
        for (const rule of this.rules) {
            if (Array.isArray(rule)) {
                const slotId = rule[0];
                const optionId = rule[1];
                if ((!slotId && !optionId) ||
                    (typeof optionId === "string" && gameManager.isOptionSelected(optionId, slotId)) ||
                    (typeof optionId === "object" && optionId.some((it) => gameManager.isOptionSelected(it, slotId)))) {
                    (rule[2] as StoryInjection).execute(storyCreator, cb);
                    return;
                }
            } else {
                rule.execute(storyCreator, cb);
                return;
            }
        }
        cb();
    }

    public getAssets(): Array<HLF.IAsset<any>> {
        return this.rules.reduce<Array<HLF.IAsset<any>>>((a, t) => {
            if (Array.isArray(t)) {
                a.push(...t[2].getAssets());
            } else {
                a.push(...t.getAssets());
            }
            return a;
        }, []);
    }
}
